<template>
    <div id="archives">
        <AppBreadCrumb :paths="[{ title: $t('message.offlineSupportRequests') }]" :select="true">
            <select v-if="tabIndex === 1" id="time-select" v-model="timeSelect">
                <option value="today">{{ $t("time.today") }}</option>
                <option value="yesterday">{{ $t("time.yesterday") }}</option>
                <option value="current-week">
                    {{ $t("time.currentWeek") }}
                </option>
                <option value="last-week">{{ $t("time.lastWeek") }}</option>
                <option value="current-month">
                    {{ $t("time.currentMonth") }}
                </option>
                <option value="last-month">{{ $t("time.lastMonth") }}</option>
                <option value="last-30">{{ $t("time.last30Day") }}</option>
                <option value="all-time">{{ $t("time.allTime") }}</option>
            </select>
        </AppBreadCrumb>
        <!--
                <b-container fluid>
                    <a-tabs :animated="false" default-active-key="1" @change="tabChanged">
                        <a-tab-pane key="1" :tab="$t('message.waitingReply')">
                            <AwaitReply/>
                        </a-tab-pane>
                        <a-tab-pane key="2" :tab="$t('message.archive')">
                            <OfflineRequestArchives :time-select="timeSelect"/>
                        </a-tab-pane>
                    </a-tabs>
                </b-container>
        -->
        <div class="position-relative pt-3" style="padding: 0 30px">
            <a-row>
                <a-col span="12" style="margin-bottom: 10px" @change="updateQueryParams()">
                    <div class="d-flex">
                        <a-button
                            :class="{
                                'menu-button': tabIndex !== 0,
                                'selected-link': tabIndex === 0,
                            }"
                            class="menu-button-base"
                            @click="tabIndex = 0"
                        >
                            <OfflineSupWaiting
                                :fill="tabIndex === 0 ? '#03a9f4' : '#808184'"
                                style="margin-bottom: -1px; width: 1.25em; margin-right: 1em"
                            />
                            <!--  <OSRWaitingAnswer class="mr-3" />-->
                            <span style="margin-left: 4px">{{ $t("message.waitingReply") }}</span>
                        </a-button>

                        <a-button
                            :class="{
                                'menu-button': tabIndex !== 1,
                                'selected-link': tabIndex === 1,
                            }"
                            class="menu-button-base"
                            @click="tabIndex = 1"
                        >
                            <!--                            <font-awesome-icon class="mr-3" icon="history"/>-->
                            <!--                            {{ $t('message.archive') }}-->
                            <ArchiveIcon
                                :fill="tabIndex === 1 ? '#03a9f4' : '#808184'"
                                style="margin-bottom: -1px; width: 1.25em; margin-right: 1em"
                            />
                            <!--  <OSRWaitingAnswer class="mr-3" />-->
                            <span style="margin-left: 4px">{{ $t("message.archive") }}</span>
                        </a-button>
                    </div>
                </a-col>
                <a-col span="24">
                    <AwaitReply v-if="tabIndex === 0" style="padding-left: 0 !important" />
                    <OfflineRequestArchives v-if="tabIndex === 1" :time-select="timeSelect" />
                </a-col>
            </a-row>
        </div>
        <ChatBar v-if="!isAdmin" :visible="false" />
    </div>
</template>

<script>
import { Settings } from "luxon";

import { log2 } from "../../utils/log2";
import OfflineRequestArchives from "../../components/OfflineRequestArchives";
import AwaitReply from "../../components/AwaitReply";
import AppBreadCrumb from "../../components/common/AppBreadCrumb";
import OSRWaitingAnswer from "../../components/svg/OSRWaitingAnswer";
import ArchiveIcon from "../../components/svg/ArchiveIcon";
import OfflineSupWaiting from "../../components/svg/OfflineSupWaiting";
import { sendSocketMessage } from "../../utils/socketStream";
import * as _ from "lodash";
import { mapActions, mapState } from "vuex";
import ChatBar from "../../components/ChatBar";

Settings.defaultLocale = "tr";
const log = log2("OfflineSupportRequests");

export default {
    name: "OfflineSupportRequests",
    data() {
        return {
            timeSelect: "today",
            tabIndex: this.$route.query.tabIndex ? parseInt(this.$route.query.tabIndex) : 0,
        };
    },
    components: {
        AwaitReply,
        OfflineRequestArchives,
        AppBreadCrumb,
        OSRWaitingAnswer,
        ArchiveIcon,
        OfflineSupWaiting,
        ChatBar,
    },
    computed: {
        ...mapState({
            isAdmin: (state) => state.auth.adminUser != null,
            languages: (state) => state.language.languages,
            settings: (state) => state.setting.settings,
            defaultLang: (state) => state.setting.settings.language.clientDefault,
        }),
    },
    methods: {
        updateQueryParams(key, value) {
            if (value === "" || value == null) {
                let query = Object.assign({}, this.$route.query);
                delete query[key];
                this.$router.replace({ query });
            } else {
                let { query } = this.$route;
                this.$router.replace({
                    query: { ...query, [key]: encodeURI(value) },
                });
            }
        },
    },

    mounted() {
        this.tabIndex = this.isAdmin ? 1 : this.tabIndex;
    },
    watch: {
        tabIndex(newValue, oldValue) {
            this.updateQueryParams("tabIndex", newValue);
            this.timeSelect = "today";
        },
    },
    beforeDestroy() {
        this.updateQueryParams("tabIndex", "");
    },
};
</script>

<!--<style lang="scss">
/*.md-tabs {
    margin-bottom: 24px;
}

.md-ripple {
    text-transform: capitalize !important;
}

.md-tabs-container {
    transition: none !important;
}*/
</style>-->
<style lang="scss">
.new-theme {
    .custom-table {
        background-color: #ffffff;
        border-radius: 6px;
        padding: 10px 20px;
    }

    #time-select {
        border: none;
        background-color: #f3f6f9;
        padding: 3px 10px;
        border-radius: 6px;
        font-size: 12px;
        font-family: Poppins;
        font-weight: bolder;
        color: #3699ff;
    }

    .chatListSettingContainer {
        display: flex;
        justify-content: left;
        width: 40%;
        position: absolute;
        margin-top: 2px;
        z-index: 50;

        div {
            margin-right: 10px;
        }
    }

    .right-floated-nav-item {
        position: absolute;
        right: 0;
    }

    .selected-link {
        color: #03a9f4;
        border: none;
        border-radius: initial;
        border-bottom: 2px solid #03a9f4;
        margin-right: 4px;
    }

    svgIcon {
        fill: #03a9f4;
    }

    svgIconTabChange {
        fill: #808184;
    }

    .menu-button {
        margin-right: 4px;
        border: none;
    }

    .menu-button-base {
        background: transparent !important;
    }
}
</style>

<style lang="scss" scoped>
#osr-form {
    .actionButton {
        border: none;
        box-shadow: none;
    }

    .modal-header {
        border: none !important;
    }

    .modal-title {
        font-weight: bold;
        font-size: 22px;
        font-family: Roboto;
    }

    .modal-form-label {
        color: #9ba2b6;
        font-weight: bold;
    }

    .modal-content {
        /*border-radius: 29px;*/
        box-shadow: 0 0 16px 0 rgba(12, 12, 12, 0.24);
        padding: 20px 20px 20px 20px;
    }

    input,
    select {
        /*border-radius: 30.5px;*/
        height: 50px;
    }

    button {
        /*border-radius: 30.5px;
        height: 50px;*/
        float: right;
        margin-left: 10px;
    }

    .close {
        color: #f44f4f;
        font-size: 30px;
        padding-left: 113px !important;
    }

    .modal-form-label {
        color: #9ba2b6;
        font-weight: bold;
    }

    .form-group {
        label {
            color: #9ba2b6;
            font-weight: bold;
        }

        legend {
            color: #9ba2b6;
            font-weight: bold;
        }
    }

    .custom-control-label {
        color: #4b5361 !important;
        font-weight: normal !important;
    }

    .osr-desc {
        height: 82px;
    }
}
</style>
